import { createClient } from '@supabase/supabase-js'
import { SupabaseClientOptions } from '@supabase/supabase-js/dist/module/lib/types'
import { Database } from './supabase_types_override'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY
const options: SupabaseClientOptions<"public"> = {}

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, options)
